import { Injectable } from '@angular/core';

import { cloneDeep } from 'lodash';
import { UnionCheckRelation } from '../types/validator.types';

@Injectable({
  providedIn: 'root'
})
export class UnionCheckRelationService {
  relations: UnionCheckRelation[] = [
    { name: 'æ', operator: '||' },
    { name: 'ä¸', operator: '&&' }
  ];
  constructor() {}

  getUnionRelations() {
    return cloneDeep(this.relations);
  }
}
